/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');
const request = require('superagent');
const _ = require('lodash');

const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const AnswerActions = require('../../actions/AnswerActions.jsx');
const AnswerStore = require('../../stores/AnswerStore.jsx');
const ProductStore = require('../../stores/ProductStore.jsx');
const ValidatorStore = require('../../stores/ValidatorStore.jsx');
const QuestionStore = require('../../stores/QuestionStore.jsx');

const DialogRenderer = require('../renderers/DialogRenderer.jsx');
const FormRenderer = require('../renderers/FormRenderer.jsx');

const ToolbarSection = React.createClass({
  mixins: [Reflux.connect(ValidatorStore, 'validationData')],

  handleClickFacebook() {
    AnswerActions.submitPartial(this.socialCallback.bind(null, 'facebook'));
  },
  handleClickTwitter() {
    AnswerActions.submitPartial(this.socialCallback.bind(null, 'twitter'));
  },
  handleClickPinterest() {
    AnswerActions.submitPartial(this.socialCallback.bind(null, 'pinterest'));
  },
  handleClickEmail() {
    AnswerActions.submitPartial(this.socialCallback.bind(null, 'email'));
  },
  socialCallback(type, config_id, image_url) {
    const methodTarget = _.get(Config, ['socialSharing', type]);
    const method = _.get(window, methodTarget);

    if (method && typeof method === 'function') {
      method(config_id, image_url);
    }
  },

  handleClickSave() {
    AnswerActions.submitPartial(this.saveCallback);
    return false;
  },
  saveCallback(config_id, image_url) {
    const wishlistMethodTarget = _.get(Config, ['socialSharing', 'wishlist']);
    const wishlistMethod = _.get(window, wishlistMethodTarget);
    const checkLoginMethodTarget = Config.checkLogin;
    const checkLoginMethod = _.get(window, checkLoginMethodTarget);

    if (wishlistMethod && typeof wishlistMethod === 'function') {
      if (checkLoginMethod && typeof checkLoginMethod === 'function') {
        checkLoginMethod(wishlistMethod, { config_id, image_url })
      } else {
        wishlistMethod(config_id, image_url);
      }
    }
  },
  saveBeforeShareCallback(config_id, image_url) {
    const ringOnlyQuestionIdList = ['10', '123', '353', '363', '447', '612', '653', '741', '1109', '1169'];
    const shareMethodTarget = _.get(Config, ['socialSharing', 'share']);
    console.log('share Method Target: ', shareMethodTarget);
    const shareMethod = _.get(window, shareMethodTarget);
    console.log('share Method: ', shareMethod);
    const { valid } = ValidatorStore.getValidationData();
    console.log('shared valid config: ', valid);
    var allQuestion = QuestionStore.data;
    var isRing = false;
    if (allQuestion && allQuestion.length > 0) {
      allQuestion.forEach((q) => {
        if (ringOnlyQuestionIdList.includes(q.id)) isRing = true;
      });
    }
    console.log('shared product is ring: ', isRing);

    if (shareMethod && typeof shareMethod === 'function') {
        shareMethod(config_id, image_url, valid, isRing);
    }
  },
  handleClickShare() {
    AnswerActions.submitPartial(this.saveBeforeShareCallback)
  },
  handleClickPrint() {
    // validate answers, display either not-finished dialog or student-data dialog
    AnswerActions.printConfiguration(this.showValidationDialog, this.showPrintDialog);
    return false;
  },

  showPrintDialog(payload) { 
    // display dialog to collect student information
    this.refs.printDialog.showDialog(null, null, payload);
  },

  showValidationDialog(invalidQuestions) {
    this.refs.validationDialog.showDialog(null, invalidQuestions);
  },

  validatePrintForm() {
    return this.refs.printDialogForm.validateForm();
  },

  printConfiguration(payload) {
    // compose payload and student data for consumption in order form
    let answers = {
      bandSize: '',
      metal: [],
      side: [],
      stone: [],
      carePlan: [],
      studentClass: '',
      other: []
    };

    // sort answers by question type
    _.each(payload.answers, answer => {
      let question = QuestionStore.getQuestionById(answer.question.id);
      let questionType = _.get(question, 'metadata.OrderFormSection');

      switch (questionType) {
        case 'bandSize':
          answers.bandSize = answer.part.name || answer.part.db_name;
          break;
        case 'metal':
          answers.metal.push(answer);
          break;
        case 'side':
          answers.side.push(answer);
          break;
        case 'stone':
          answers.stone.push(answer);
          break;
        case 'carePlan':
          answers.carePlan.push(answer);
          break;
        case 'studentClass':
          answers.studentClass = answer.part.name || answer.part.db_name;
          break;
        case 'ignore':
          break;
        default:
          answers.other.push(answer);
      }
    });

    // @TODO: probably should clean up image url strings at the source but need to make sure it doesn't break existing functionality, isolated here for now
    let data = {
      studentData: this.refs.printDialogForm.getFormData(),
      productName: ProductStore.getProductName(),
      price: payload.price,
      schoolName: ProductStore.getSchoolName(),
      answers: answers,
      topImage: AnswerStore.getImageUrlByView('top').replace(/ /g, '%20'),
      side1Image: AnswerStore.getImageUrlByView('side1').replace(/ /g, '%20'),
      side2Image: AnswerStore.getImageUrlByView('side2').replace(/ /g, '%20')
    };

    if (!_.get(Config, 'api.highSchoolOrderForm')) {
      throw new Error('No URL found for High School Order Form');
    }
    // XHR request to generate PDF
    request
      .post(_.get(Config, 'api.highSchoolOrderForm'))
      .send(data)
      .type('json')
      .end((err, res) => {
        if (res.error) {
          console.error(err.response);
          alert('There has been an error generating your order form. Please try again later.');
        } else {
          let link = document.createElement('a');
          link.href = res.text;
          link.download = 'filename';
          link.style.display = 'none';

          let uc = document.getElementById('uc');
          uc.appendChild(link);

          let clickEvent;

          if (document.createEvent) {
            // IE / FireFox
            clickEvent = document.createEvent('MouseEvent');
            clickEvent.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          } else {
            // Chrome etc.
            clickEvent = new MouseEvent('click', {
              'view': window,
              'bubbles': true,
              'cancelable': false
            });
          }

          link.dispatchEvent(clickEvent);
          uc.removeChild(link);
        }
      });
  },

  render() {
    let printActiveClass = _.get(this.state, 'validationData.valid') ? ' active' : '';
    let printButton = (ProductStore.getProductLineId() == Config.productline.ScholasticHighSchoolRings && !Config.features.socialShareButtonOnly) ?
      <button className={'fa fa-print' + printActiveClass} title="Print your ring design" onClick={this.handleClickPrint}> </button>
      : null;
    let socialStyling = {
      display: (Config.features.socialSharingPrintOnly || Config.features.socialShareButtonOnly) ? 'none' : 'inline'
    };

    let saveButton = ProductStore.getProductLineId() == Config.productline.KSUNIVCollections ? 
    <button className="uc-save-button" onClick={this.handleClickSave}>
          <i className="fa fa-diamond"> </i>
          {Config.features.saveMyDesignText[ln] || Config.features.saveMyDesignText[en_US]}
        </button> 
    :
    <button className="uc-save-button" onClick={this.handleClickSave}>
          <i className="fa fa-floppy-o"> </i>
          {Config.features.saveMyDesignText[ln] || Config.features.saveMyDesignText[en_US]}
      </button>

    let shareButton = Config.features.socialShareButtonOnly ?
      <button className="uc-share-button" title="Email or SMS your ring design" onClick={this.handleClickShare}>
      <i className={'fa fa-envelope-o uc-small'}> </i>
      {Config.features.shareMyDesignText[ln] || Config.features.shareMyDesignText[en_US]}
      <i className={'fa fa-envelope-o uc-medium-up'}> </i>
      </button>
      : null;

    let toolbarClass = "uc-toolbar-section" + (this.props.section ? " uc-" + this.props.section : "");

    return (
      <div className={toolbarClass}>
        <div className="uc-share-msg">Share your Ring Design with friends and family!</div>

        {shareButton}

        {saveButton}

        <div className="uc-social-icons">
          <button style={socialStyling} className="fa fa-facebook" title="Share on Facebook" onClick={this.handleClickFacebook}> </button>
          <button style={socialStyling} className="fa fa-pinterest-p" title="Share on Pinterest" onClick={this.handleClickPinterest}> </button>
          <button style={socialStyling} className="fa fa-twitter" title="Share on Twitter" onClick={this.handleClickTwitter}> </button>
          <button style={socialStyling} className="fa fa-envelope-o" title="Email a link to this ring to a friend" onClick={this.handleClickEmail}> </button>
          {printButton}
        </div>

        <DialogRenderer
          ref="printDialog"
          title="<h1>Print Your Ring Design</h1>"
          buttons={[{
            text: 'Print',
            action: this.printConfiguration,
            validate: this.validatePrintForm,
            btnClass: 'uc-primary-btn'
          }]}>
          Please complete the following to print your design:
          <FormRenderer
            ref="printDialogForm"
            fields={[
              { name: 'name', label: 'Name', type: 'text', value: Loader.customerName, required: Config.features.requireCustomerDataForPrint },
              { name: 'address', label: 'Address', type: 'text', value: Loader.customerAddress, required: Config.features.requireCustomerDataForPrint },
              { name: 'city', label: 'City', type: 'text', value: Loader.customerCity, required: Config.features.requireCustomerDataForPrint },
              { name: 'state', label: 'State', type: 'text', value: Loader.customerState, required: Config.features.requireCustomerDataForPrint },
              { name: 'zip-code', label: 'Zip Code', type: 'text', value: Loader.customerZip, required: Config.features.requireCustomerDataForPrint },
              { name: 'phone', label: 'Phone', type: 'tel', value: Loader.customerPhone, required: Config.features.requireCustomerDataForPrint }
            ]} />
        </DialogRenderer>

        <DialogRenderer
          ref="validationDialog"
          title="<h1>Not Quite Finished Yet!</h1>"
          buttons={[{ text: 'OK', btnClass: 'uc-primary-btn' }]}>
          The following questions are incomplete or have errors:
        </DialogRenderer>
      </div>
    );
  }
});

module.exports = ToolbarSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/ToolbarSection.jsx